<page-content [fullPageWidth]="true">
    <header-elitment header
                     [hasSideMenu]="true">
    </header-elitment>
    <side-menu left-menu>
        <evaluation-athlete-side-menu side-menu
            [evaluationAthlete]="evaluationAthlete"
            [organization]="organization"
            [athleteUser]="athleteUser"
            [evaluationsAthletes]="evaluationsAthletes">
        </evaluation-athlete-side-menu>
    </side-menu>
    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>
    <div class="editor">
        <div class="evaluation-athlete-show">
            <module-content *ngIf="!is401 && !is404"
                            [title]="evaluationAthlete.evaluation?.title ?? ''"
            >
                <mat-card-header class="evaluation-athlete-status">
                    <mat-card-subtitle>
                        <mat-chip-set>
                            <mat-chip [ngClass]="evaluationAthlete.status === 'opened' ? 'mat-chip-accent' : ''">{{ evaluationAthlete.status??'' | translate }}</mat-chip>
                        </mat-chip-set>
                    </mat-card-subtitle>
                </mat-card-header>
                <mat-card-content class="evaluation-athlete-content mb-20">
                    <div class="evaluation-athlete-date mb-10">{{ 'EvaluationOf' | translate:{date: (evaluationAthlete.date|appDate:'mediumDate')} }}</div>
                    <div class="evaluation-athlete-descriptions">{{ evaluationAthlete.evaluation?.description }}</div>
                </mat-card-content>

                <div class="header">
                    <form [formGroup]="evaluationForm">
                        <fieldset [disabled]="isSubmitting">
                            <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="20px" class="mt-40">
                                <!-- TODO: check rights -->
                                <div [fxFlex]="100">
                                    <div class="questions-wrapper">
                                        <div class="user user-athlete">
                                            {{ 'evaluation_test' | translate }}
                                        </div>
                                        <div class="questions">
                                            <evaluation-athlete-question-group user="athlete"
                                                                               [athleteId]="evaluationAthlete.athleteId"
                                                                               [evaluationAthlete]="evaluationAthlete"
                                                                               [evaluationForm]="evaluationForm"
                                                                               (onFormChanged)="onFormChanged()">
                                            </evaluation-athlete-question-group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- TODO: check rights -->
                            <div>
                                <mat-form-field style="width: 100%;">
                                    <mat-label>{{ 'Evaluation_notes' | translate }}</mat-label>
                                    <textarea
                                        formControlName="notes"
                                        matInput
                                        cdkTextareaAutosize
                                        cdkAutosizeMinRows="1"
                                        cdkAutosizeMaxRows="5"></textarea>
                                </mat-form-field>
                            </div>

                        </fieldset>
                    </form>
                </div>

                <div fxLayout="row" fxLayoutAlign="start center" class="pull-left" *ngIf="evaluationAthlete.status == 'opened'">
                    <!-- TODO: check rights -->
                    <div *ngIf="!is401 && !is404">
                        <button mat-raised-button color="primary" (click)="closeEvaluation()">{{ 'CloseEvaluation' | translate }}</button>
                    </div>
                </div>
            </module-content>
        </div>
    </div>
    <!-- TODO: check rights -->
    <ng-container>
        <main-action [title]="'Save'"
                     [icon]="'check'"
                     [isLoading]="isSubmitting"
                     [disabled]="isLoading"
                     (click)="onSaveClicked()"
                     >
        </main-action>
        <!-- TODO: check rights -->
        <main-action
                     [title]="'Close_edit_mode' | translate"
                     [icon]="'close'"
                     [color]="'none'"
                     [right]="104"
                     [disabled]="isLoading"
                     [link]="'/' + organization.code + '/athletes/' + athleteUser.id +'/evaluations/' + evaluationAthlete.id"
                     >
        </main-action>
    </ng-container>
</page-content>
